import { useQuery } from '@tanstack/react-query'
import { fetchVideoCategoryDropdowns } from 'src/api'

export default function useVideoCategoryDropdowns() {
    const { data: dropdowns, isFetching } = useQuery(['dropdowns'], fetchVideoCategoryDropdowns, {
        refetchOnMount: true,
        refetchOnWindowFocus: false
    })
    return {
        categories: dropdowns,
        loading: isFetching,
    }
}
